//  React TS Base Styles
import colors from '../../base/colors'
import borders from '../../base/borders'

//  React Helper Function
import rgba from '../../functions/rgba'

const { black } = colors
const { borderWidth } = borders

// types
// types
type Types = any

const card: Types = {
  styleOverrides: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      minWidth: 0,
      wordWrap: 'break-word',
      // Brand tokens: a navy-black surface, the 10px sticker radius and the
      // flat 2px offset shadow. The default was a white card with a blurred
      // drop shadow, which every dark surface in the app had to override.
      backgroundColor: 'var(--dewi_colors_dark_8)',
      backgroundClip: 'border-box',
      border: 'none',
      borderRadius: 'var(--dewi_radius_lg)',
      boxShadow: 'none',
      overflow: 'visible',
    },
  },
}

export default card
